import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=a4c981ea&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=a4c981ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c981ea",
  null
  
)

export default component.exports